import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'design-system/button/Button'
import React from 'react'
import { useDownloadCensusTemplate } from '../../hooks/useDownloadCensusTemplate'
import styles from './DownloadCensusTemplate.module.scss'

interface DownloadCensusTemplateButtonProps {
  hasHelperText?: boolean
}

const DownloadCensusTemplateButton = ({
  hasHelperText = true,
}: DownloadCensusTemplateButtonProps) => {
  const { isLoading, downloadTemplate } = useDownloadCensusTemplate()

  return (
    <div className={styles.buttonContainer}>
      <Button
        onClick={downloadTemplate}
        variant="darkblue"
        type="outline"
        loading={isLoading}
        aria-busy={isLoading}
      >
        <DownloadOutlined style={{ marginRight: '8px' }} />
        Download Census Template
      </Button>
      {hasHelperText ? (
        <p className={styles.helperText}>
          Instructions and a sample file to help format your census upload.
        </p>
      ) : null}
    </div>
  )
}

export default DownloadCensusTemplateButton
